export const navBarText = {
  homeText: 'ASHAN PANDUWAWALA',
  homeId: 'home',
  navItems: ['INTRODUCTION', 'CODE // TECHNOLOGIES', 'EXPERIENCE', 'PROJECTS →'],
  navIds: ['introduction', 'lines-of-code', 'experience', 'projects'],
  contactId: 'contact',
  contactText: 'CONTACT',
};
